import { NgModule } from '@angular/core';
import { WikiDetailsComponent } from './wiki-details.component';
import { WikiDetailsRoutingModule } from './wiki-details-routing.module';
import { WikiService } from './wiki.service';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [WikiDetailsRoutingModule, SharedModule],
  declarations: [WikiDetailsComponent],
  exports: [WikiDetailsComponent],
  providers: [WikiService]
})
export class WikiDetailsModule { }
